var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJumpstart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.003,
    height: 27.434,
    viewBox: "0 0 20.003 27.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.584 -17.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.222,33.333h0l-.627-.557a.766.766,0,0,1-.07-.869l.672-1.172c2.279-3.943,1.2-9.627.631-11.885A1.738,1.738,0,0,0,42.66,17.62c-2.242.635-7.7,2.545-9.971,6.488l-.68,1.176a.7.7,0,0,1-.783.373l-.82-.266c-.553-.213-1.373-.475-4.791,9.721a.619.619,0,0,0,.041.484.627.627,0,0,0,.381.3,8.908,8.908,0,0,1,2.484.992,7.111,7.111,0,0,0,2.627,3.16,7.127,7.127,0,0,0,4.033.7,9.092,9.092,0,0,1,2.1,1.639.619.619,0,0,0,.434.176h.02a.6.6,0,0,0,.439-.2C45.32,34.325,44.685,33.751,44.222,33.333ZM37.693,41.1c-1.119-1.041-1.959-1.566-2.5-1.566h-.082A5.914,5.914,0,0,1,31.763,39a5.918,5.918,0,0,1-2.131-2.627c-.221-.5-1.107-.988-2.643-1.463a54.76,54.76,0,0,1,3.336-8.262l.52.172a1.93,1.93,0,0,0,2.234-.926l.676-1.189C35.8,21.149,40.906,19.374,43,18.78a.508.508,0,0,1,.639.369c.533,2.115,1.549,7.418-.5,10.971l-.676,1.172a1.979,1.979,0,0,0,.316,2.4l.41.361A54.941,54.941,0,0,1,37.693,41.1Z",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.355,39.076a2.683,2.683,0,1,0,.98,3.664h0a2.68,2.68,0,0,0-.979-3.664Zm-.086,3.037a1.447,1.447,0,1,1-.529-1.979A1.447,1.447,0,0,1,52.269,42.112Z",
    transform: "translate(-13.428 -12.493)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.478,77a.615.615,0,0,0-.84.225L39.606,79a.619.619,0,0,0,.225.82.652.652,0,0,0,.307.082.615.615,0,0,0,.533-.307L41.7,77.809A.619.619,0,0,0,41.478,77Z",
    transform: "translate(-8.232 -35.037)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.391,73.621a.615.615,0,0,0-.84.225l-1.885,3.279a.619.619,0,0,0,.225.82.607.607,0,0,0,.307.082.615.615,0,0,0,.533-.307l1.885-3.279A.615.615,0,0,0,34.391,73.621Z",
    transform: "translate(-3.546 -33.043)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.76,70.239a.611.611,0,0,0-.84.225l-1.029,1.783a.611.611,0,0,0,.225.82.582.582,0,0,0,.3.082.623.623,0,0,0,.537-.307l1.029-1.783a.615.615,0,0,0-.225-.82Z",
    transform: "translate(-1.317 -31.046)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpstart);
export default __webpack_public_path__ + "static/media/jumpstart.53a878a3.svg";
export { ForwardRef as ReactComponent };